import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateDERequest } from "./add-documento-electronico";
import { MutationConfig } from "@/shared/types/base";
import { notify } from "@/shared/notification";

export interface CamposBorrarDE {
    camposInutilizacionDE: CamposInutilizacionDE;
    camposNCE: CreateDERequest;
}

export interface CamposInutilizacionDE {
    CDC: string;
    DNumTim: string;
    DEst: string;
    DPuntExp: string;
    DNumIn: number;
    DNumFin: number;
    ITiDE: number;
    MOtEve: string;
}

export interface DeleteDEResponse {
    nceGenerada?: {
        idDE: string;
        cdc: string;
        kuDEBase64: string;
        docNumDE: string;
    };
    message?: string;
}

// Borrar DE

interface DeleteDEParams {
    id: string;
    request: CamposInutilizacionDE;
}

async function deleteDocumentoElectronico({ request }: DeleteDEParams): Promise<DeleteDEResponse> {
    const response = await api.post<DeleteDEResponse>("/de/borrarDE", request);
    return response.data;
}

export function useDeleteDocumentoElectronicoMutation(mutationConfig: MutationConfig<DeleteDEResponse> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: deleteDocumentoElectronico,
        onSuccess: (data, params, ...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(data, params, ...args);
            notify(data?.message || "Documento Electrónico borrado correctamente", { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["de", params.id] });
            queryClient.invalidateQueries({ queryKey: ["documentos-electronicos"] });
        },
        onError: (...args) => {
            mutationConfig.onError && mutationConfig.onError(...args);
            const error = args[0] as any;
            notify(error.response?.data?.message || "Error al borrar el Documento Electrónico", { variant: "error" });
        },
    });
}

// Borrar FE

interface DeleteFEParams {
    id: string;
    request: CamposInutilizacionDE;
}

async function deleteFacturaElectronica({ request }: DeleteFEParams): Promise<DeleteDEResponse> {
    const response = await api.post<DeleteDEResponse>("/de/borrarFE", request);
    return response.data;
}

export function useDeleteFacturaElectronicaMutation(mutationConfig: MutationConfig<DeleteDEResponse> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: deleteFacturaElectronica,
        onSuccess: (data, params, ...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(data, params, ...args);
            notify(data?.message || "Factura Electrónica borrada correctamente", { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["de", params.id] });
            queryClient.invalidateQueries({ queryKey: ["documentos-electronicos"] });
        },
        onError: (...args) => {
            mutationConfig.onError && mutationConfig.onError(...args);
            const error = args[0] as any;
            notify(error.response?.data?.message || "Error al borrar la Factura Electrónica", { variant: "error" });
        },
    });
}
